import { render, staticRenderFns } from "./CreateReceiverPage.vue?vue&type=template&id=f2635f9e&"
import script from "./CreateReceiverPage.vue?vue&type=script&lang=ts&"
export * from "./CreateReceiverPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports